import React from 'react';
import SearchComponent from './SearchComponent';
import Navbar from './Navbar';
import HeroBackground from '../assets/NYD-banner-header-1440x560.jpg';

function Header() {
  return (
    <header className="relative text-white text-center">
      <Navbar />
      
      {/* Contenedor con la proporción real de la imagen (1440x560) para que nunca recorte los costados */}
      <div className="relative w-full aspect-[1440/560] overflow-hidden">
        <img
          src={HeroBackground}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
        />
      </div>
      
      {/* Buscador - En mobile más pegado a la imagen */}
      <div className="relative -mt-12 md:-mt-24 lg:-mt-20 z-20 container mx-auto px-3 md:px-4">
        <div className="shadow-[0_10px_40px_rgba(0,0,0,0.6)] rounded-3xl">
          <SearchComponent />
        </div>
      </div>
    </header>
  );
}

export default Header;